/* Commons Studios storefront behaviour. No dependencies. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var html = document.documentElement;
  html.classList.remove('no-js');

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function store(key, val) { try { if (val === undefined) return sessionStorage.getItem(key); sessionStorage.setItem(key, val); } catch (e) { return null; } }

  /* Logo loader: once per session. The class is added early by an inline script in the header section. */
  function finishLoader() {
    html.classList.remove('cmns-loading');
    store('cmnsLoaded', '1');
    document.dispatchEvent(new CustomEvent('cmns:loaded'));
  }
  if (html.classList.contains('cmns-loading')) { setTimeout(finishLoader, 1600); }
  else { setTimeout(function () { document.dispatchEvent(new CustomEvent('cmns:loaded')); }, 0); }

  /* Header: becomes fixed past the announcement bar, hides on scroll down, returns on scroll up. */
  function initHeader() {
    var header = $('[data-cmns-header]');
    if (!header) return;
    var spacer = header.nextElementSibling;
    var lastY = window.scrollY;
    var startY = 0;
    function measure() { startY = spacer.getBoundingClientRect().top + window.scrollY; }
    measure();
    window.addEventListener('resize', measure);
    function onScroll() {
      var y = window.scrollY;
      if (y > startY) header.classList.add('is-fixed'); else header.classList.remove('is-fixed', 'is-hidden');
      if (y > startY + 55 && y > lastY && !header.matches(':hover') && !header.contains(document.activeElement)) header.classList.add('is-hidden');
      else if (y < lastY) header.classList.remove('is-hidden');
      lastY = y;
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Announcement: rotate messages, live drop countdown. */
  function initAnnouncement() {
    $$('[data-cmns-announce]').forEach(function (bar) {
      var msgs = $$('.cmns-announce__msg', bar);
      var countdown = $('[data-cmns-countdown]', bar);
      if (countdown) {
        var end = new Date(countdown.getAttribute('data-ends')).getTime();
        var out = $('.cmns-announce__num', countdown);
        var pad = function (n) { return String(n).padStart(2, '0'); };
        var tick = function () {
          var s = Math.floor((end - Date.now()) / 1000);
          if (isNaN(end) || s <= 0) { countdown.hidden = true; if (msgs.length) msgs[0].hidden = false; return false; }
          var d = Math.floor(s / 86400); s -= d * 86400;
          var txt = (d ? d + 'd : ' : '') + pad(Math.floor(s / 3600)) + 'h : ' + pad(Math.floor((s % 3600) / 60)) + 'm : ' + pad(s % 60) + 's';
          out.textContent = txt;
          return true;
        };
        if (tick()) { msgs.forEach(function (m) { m.hidden = true; }); var t = setInterval(function () { if (!tick()) clearInterval(t); }, 1000); return; }
      }
      if (msgs.length < 2 || reduced) return;
      var i = 0;
      setInterval(function () { msgs[i].hidden = true; i = (i + 1) % msgs.length; msgs[i].hidden = false; }, 4000);
    });
  }

  /* Drawers and modal */
  var lastFocus = null;
  function openLayer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var f = el.querySelector('button, a, input, select');
    if (f) setTimeout(function () { f.focus(); }, 50);
    document.dispatchEvent(new CustomEvent('cmns:layer-open', { detail: el }));
  }
  function closeLayer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
    document.dispatchEvent(new CustomEvent('cmns:layer-close', { detail: el }));
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-cmns-open]');
    if (opener) { e.preventDefault(); openLayer(document.getElementById(opener.getAttribute('data-cmns-open'))); return; }
    var closer = e.target.closest('[data-cmns-close]');
    if (closer) { e.preventDefault(); closeLayer(closer.closest('.cmns-drawer, .cmns-modal')); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = $('.cmns-drawer.is-open, .cmns-modal.is-open');
    if (open) closeLayer(open);
  });

  /* Collection tabs */
  function initTabs(ctx) {
    $$('[data-cmns-tabs]', ctx).forEach(function (wrap) {
      var btns = $$('[role="tab"]', wrap);
      function select(btn) {
        btns.forEach(function (b) {
          var on = b === btn;
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(b.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () { select(b); });
        b.addEventListener('keydown', function (e) {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          var n = btns[(i + (e.key === 'ArrowRight' ? 1 : btns.length - 1)) % btns.length];
          select(n); n.focus();
        });
      });
    });
  }

  /* Product card image carousel */
  function initCards(ctx) {
    $$('.cmns-card__slide img', ctx).forEach(function (img) {
      if (img.complete) img.classList.add('is-loaded');
      else img.addEventListener('load', function () { img.classList.add('is-loaded'); });
    });
    $$('[data-cmns-card]', ctx).forEach(function (card) {
      if (card.dataset.ready) return;
      card.dataset.ready = '1';
      var track = $('.cmns-card__track', card);
      var dots = $$('.cmns-card__dots i', card);
      if (!track || dots.length < 2) return;
      function go(dir) { track.scrollBy({ left: dir * track.clientWidth, behavior: reduced ? 'auto' : 'smooth' }); }
      $$('[data-cmns-prev]', card).forEach(function (b) { b.addEventListener('click', function () { go(-1); }); });
      $$('[data-cmns-next]', card).forEach(function (b) { b.addEventListener('click', function () { go(1); }); });
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      }, { passive: true });
    });
  }

  /* Banner text fade in on view */
  function initBanners() {
    var els = $$('.cmns-banner');
    if (!els.length) return;
    if (!('IntersectionObserver' in window) || reduced) { els.forEach(function (el) { el.classList.add('is-inview'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-inview'); io.unobserve(en.target); } });
    }, { threshold: 0.3 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* Psst bar: slides up after the loader, opens Klaviyo form or the built-in modal. */
  function initPsst() {
    var bar = $('[data-cmns-psst]');
    if (!bar) return;
    var label = $('[data-cmns-psst-label]', bar);
    var base = label.textContent;
    var hover = bar.getAttribute('data-hover-text') || base;
    var show = function () { bar.classList.add('is-visible'); };
    if (html.classList.contains('cmns-loading')) document.addEventListener('cmns:loaded', show, { once: true }); else setTimeout(show, 300);
    ['mouseenter', 'focus'].forEach(function (ev) { bar.addEventListener(ev, function () { label.textContent = hover; }); });
    ['mouseleave', 'blur'].forEach(function (ev) { bar.addEventListener(ev, function () { label.textContent = base; }); });
    if (location.hash.indexOf('CmnsEarlyAccessForm') > -1) openLayer(document.getElementById('CmnsEarlyAccess'));
    var kl = bar.getAttribute('data-klaviyo-form');
    bar.addEventListener('click', function () {
      if (kl) { window._klOnsite = window._klOnsite || []; window._klOnsite.push(['openForm', kl]); }
      else openLayer(document.getElementById('CmnsEarlyAccess'));
    });
    document.addEventListener('cmns:layer-open', function () { bar.classList.add('is-away'); });
    document.addEventListener('cmns:layer-close', function () { bar.classList.remove('is-away'); });
    window.addEventListener('klaviyoForms', function (e) {
      if (!e.detail) return;
      if (e.detail.type === 'open') bar.classList.add('is-away');
      if (e.detail.type === 'close') bar.classList.remove('is-away');
    });
  }

  /* Cart: drawer content comes from the cmns-cart-drawer section via the Section Rendering API. */
  function refreshCart(open) {
    return fetch(root + '?section_id=cmns-cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var fresh = doc.querySelector('[data-cmns-cart-content]');
        var current = $('[data-cmns-cart-content]');
        if (fresh && current) current.replaceWith(fresh);
        var count = fresh ? fresh.getAttribute('data-count') : null;
        if (count !== null) $$('[data-cmns-cart-count]').forEach(function (el) { el.textContent = count; });
        if (open) openLayer(document.getElementById('CmnsCart'));
      });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-cmns-product-form]');
    if (!form || !document.getElementById('CmnsCart')) return;
    e.preventDefault();
    var btn = $('[type="submit"]', form);
    var err = $('[data-cmns-form-error]', form);
    if (btn) btn.disabled = true;
    if (err) err.textContent = '';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add to bag.');
        return refreshCart(true);
      })
      .catch(function (x) { if (err) err.textContent = x.message; })
      .then(function () { if (btn) btn.disabled = false; });
  });
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cmns-line]');
    if (!b) return;
    e.preventDefault();
    fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(b.getAttribute('data-cmns-line')), quantity: Number(b.getAttribute('data-qty')) })
    }).then(function () { return refreshCart(false); });
  });

  /* Product page: match selected options to a variant. */
  function initProduct() {
    $$('[data-cmns-pdp]').forEach(function (wrap) {
      var data = $('[data-cmns-variants]', wrap);
      if (!data) return;
      var variants = JSON.parse(data.textContent);
      var form = $('[data-cmns-product-form]', wrap);
      var idInput = $('[data-cmns-variant-id]', form);
      var btn = $('[type="submit"]', form);
      var priceEl = $('[data-cmns-price]', wrap);
      var fmt = wrap.getAttribute('data-money-format') || '${{amount}}';
      function money(cents) {
        var n = (cents / 100).toFixed(2).replace(/\.00$/, '');
        return fmt.replace(/\{\{\s*\w+\s*\}\}/, n);
      }
      function update() {
        var chosen = $$('.cmns-opt', form).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === chosen[i]; }); });
        if (!v) { btn.disabled = true; btn.textContent = btn.getAttribute('data-unavailable'); return; }
        idInput.value = v.id;
        btn.disabled = !v.available;
        btn.textContent = v.available ? btn.getAttribute('data-add') : btn.getAttribute('data-sold-out');
        if (priceEl) {
          var sale = v.compare_at_price && v.compare_at_price > v.price;
          priceEl.classList.toggle('is-sale', !!sale);
          priceEl.innerHTML = (sale ? '<s>' + money(v.compare_at_price) + '</s>' : '') + '<span>' + money(v.price) + '</span>';
        }
        if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u); }
      }
      form.addEventListener('change', function (e) { if (e.target.closest('.cmns-opt')) update(); });
    });
    $$('[data-cmns-recs]').forEach(function (el) {
      fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var inner = doc.querySelector('[data-cmns-recs-inner]');
        if (inner && inner.querySelector('[data-cmns-card]')) { el.innerHTML = inner.outerHTML; initCards(el); }
      });
    });
  }

  /* Collection: desktop pills apply instantly, the mobile sheet applies on "Show N products",
     sort keeps the current filters, load more appends the next page. */
  function filterQuery(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (v, k) { if (String(v).trim() !== '') params.append(k, v); });
    var sort = $('[data-cmns-sort]');
    if (sort && sort.value) params.set('sort_by', sort.value);
    return params.toString();
  }
  function initCollection() {
    var pops = $$('[data-cmns-fpop]');
    pops.forEach(function (d) {
      d.addEventListener('toggle', function () { if (d.open) pops.forEach(function (o) { if (o !== d) o.open = false; }); });
    });
    document.addEventListener('click', function (e) { pops.forEach(function (d) { if (d.open && !d.contains(e.target)) d.open = false; }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') pops.forEach(function (d) { if (d.open) { d.open = false; $('summary', d).focus(); } }); });

    $$('[data-cmns-filter-form]').forEach(function (form) {
      var deferred = form.getAttribute('data-mode') === 'deferred';
      form.addEventListener('submit', function (e) { e.preventDefault(); location.search = filterQuery(form); });
      form.addEventListener('change', function (e) {
        if (e.target.type === 'number') return; /* price applies on Apply or Enter */
        if (!deferred) { location.search = filterQuery(form); return; }
        /* Mobile sheet: update the result count on the button without leaving the page. */
        var count = $('[data-cmns-filter-count]'), noun = $('[data-cmns-filter-noun]');
        if (!count) return;
        var q = filterQuery(form);
        fetch(location.pathname + '?' + q + (q ? '&' : '') + 'section_id=' + form.getAttribute('data-section'))
          .then(function (r) { return r.text(); })
          .then(function (text) {
            var m = text.match(/data-cmns-count="(\d+)"/);
            if (!m) return;
            count.textContent = m[1];
            if (noun) noun.textContent = m[1] === '1' ? 'product' : 'products';
          });
      });
    });
    $$('[data-cmns-filter-apply]').forEach(function (btn) {
      btn.addEventListener('click', function () { var f = $('[data-cmns-filter-form][data-mode="deferred"]'); if (f) location.search = filterQuery(f); });
    });
    $$('[data-cmns-sort]').forEach(function (sel) {
      sel.addEventListener('change', function () {
        var params = new URLSearchParams(location.search);
        params.set('sort_by', sel.value); params.delete('page');
        location.search = params.toString();
      });
    });
    document.addEventListener('click', function (e) {
      var more = e.target.closest('[data-cmns-more]');
      if (!more) return;
      e.preventDefault();
      more.setAttribute('aria-busy', 'true');
      fetch(more.href).then(function (r) { return r.text(); }).then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var grid = $('[data-cmns-coll-grid]');
        $$('[data-cmns-coll-grid] > *', doc).forEach(function (n) { grid.appendChild(n); });
        initCards(grid);
        var next = $('[data-cmns-more]', doc);
        if (next) { more.href = next.href; more.removeAttribute('aria-busy'); } else more.parentNode.remove();
      });
    });
  }

  function init() {
    initHeader(); initAnnouncement(); initTabs(); initCards(); initBanners(); initPsst(); initProduct(); initCollection();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* Theme editor: re-init a section after it is edited. */
  document.addEventListener('shopify:section:load', function (e) { initTabs(e.target); initCards(e.target); initBanners(); initAnnouncement(); });
})();
